// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".guzGxIo-EC7NS25BAVL9jg\\=\\= .availability-list-heading-sort{display:none !important}", "",{"version":3,"sources":["webpack://./../../cap1-modules/hotels-module/src/modules/wishlist/styles.module.scss"],"names":[],"mappings":"AACE,4DACE,uBAAA","sourcesContent":[".wishlistListSectionOverrides {\n  :global(.availability-list-heading-sort) {\n    display: none !important\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wishlistListSectionOverrides": "guzGxIo-EC7NS25BAVL9jg=="
};
export default ___CSS_LOADER_EXPORT___;
